import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { ByTransactionRow } from 'donor-elf-web/controllers/funds/fund/campaigns/approve-transactions';
import type { SelectOption } from 'donor-elf-web/lib/form-component-utils';
import CampaignService from 'donor-elf-web/services/campaign-service';

interface ComponentArgs {
  row: ByTransactionRow;
  // pass in the options so the array only needs to be created once and
  // not for each individual component
  campaignSelectOptions: SelectOption[];
}

export default class LineItemApproveCampaignComponent extends Component<ComponentArgs> {
  @service declare campaignService: CampaignService;

  get campaign() {
    let campaignId = this.changeset.get('campaignId');
    if (isPresent(campaignId)) {
      return this.campaignService.campaignsById[campaignId];
    } else {
      return undefined;
    }
  }

  get lineItem() {
    return this.args.row.lineItem;
  }

  get changeset() {
    return this.args.row.campaignLineItemChangeset;
  }

  edit = () => {
    this.changeset.set('approved', false);
  };

  approve = async () => {
    if (this.args.row.approving) {
      return;
    }
    this.args.row.approving = true;
    let { changeset } = this;
    changeset.set('approved', true);
    await changeset.validate();
    if (changeset.get('isValid')) {
      this.args.row.showValidationErrors = false;
      try {
        await changeset.save();

        let { campaign, lineItem } = this;
        await lineItem.reload();
        if (campaign && lineItem.contactId) {
          this.campaignService.reloadCampaignContactsIfContactIdNotInCampaign({
            contactId: lineItem.contactId,
            campaignId: campaign.id,
          });
        }
      } catch (error) {
        this.changeset.set('approved', false);
        this.args.row.approveError = error;
      }
    } else {
      changeset.set('approved', false);
      this.args.row.showValidationErrors = true;
    }
    this.args.row.approving = false;
  };
}
